// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IntegrationOpenapiApiIntegrationOpenapiJsonGet200 = zod.record(zod.string(), zod.unknown())

export type IntegrationOpenapiApiIntegrationOpenapiJsonGet200 = zod.input<typeof IntegrationOpenapiApiIntegrationOpenapiJsonGet200>;
export type IntegrationOpenapiApiIntegrationOpenapiJsonGet200Output = zod.output<typeof IntegrationOpenapiApiIntegrationOpenapiJsonGet200>;
